import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { custom } from 'devextreme/ui/dialog';
import data from "../../../../assets/apiRoutes.json";
import { Button, DateBox, Popup} from 'devextreme-react';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import PrimaryTab from "./detailtabs/PrimaryTab";
import PrimaryTabComment from "./detailtabs/PrimaryTabComment";
import LocationsTab from "./detailtabs/LocationsTab";
import SubLotDetailTabs from "./detailtabs/SubLotDetailTabs";
import ChargesTab from "./detailtabs/ChargesTab";
import LotInfoTab from "./detailtabs/LotInfoTab";
import SerialNumbersTab from "./detailtabs/SerialNumbersTab";
import RenderSelectBoxCell from "../../../../common/RenderCell";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
import { GetFormatedDateWithTime, FormatPhoneNumber, dateTimeToJulian, getKeyByValue } from '../../../../common/Utils'
import { ERROR_SEVERITY, formatErrorList } from '../../../../common/apiErrors'
import { createConcurrencyAwareStore, refreshGridOnConflict } from '../../../../common/dataStore'
import notify from 'devextreme/ui/notify';
import DropDownButton from "devextreme-react/drop-down-button";
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
 import { ItemTypes, Options, ShipSelection, TransactionTypes,
    ReceivingMethodLot,
    ShowMasterLot, LocationStatus, TransactionStage, WMTransactionDetailsOptions,
    TransactionStatus,
    YesNo,
    Statuses,
    TransactionStageEnum} from "../../../../enum/Enum";
 
import {
    Column,
    DataGrid,
    LoadPanel as DataGridLoadPanel,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Export,
    Sorting,
    Paging,
    Pager,
    Toolbar as DataGridToolbar,
    Item as DataGridToolbarItem,
    Editing,
    FilterRow,
    FilterPanel,
    StateStoring,
    Lookup
} from "devextreme-react/data-grid";

import axios from "axios";
import AdditionalTab from "./detailtabs/AdditionalTab";
import QuickLotEntryScreen from "../../codes/lotDataEntry/QuickLotEntryScreen";
import GenerateLotSerialNumbers from "../../codes/lotDataEntry/GenerateLotSerialNumbers";

import CommentTab from "./detailtabs/CommentTab";
import UserDefinedTab from "./detailtabs/UserDefinedTab";
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox } from "devextreme-react";
import DataSource from "devextreme/data/data_source";
import { MESSAGES } from "../../../../common/Messages";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../../../common/concurrency";
import LotDataEntryForm from "../../codes/lotDataEntry/Form";
import { WM, WMSInventoryUOMFlag } from "../../../../const/constants";
import { MethodShipments, LotPickMethodShipments,SublotPickMethodShipments,UnitPickMethodShipments, PickSequence, PopulateLotWithCarrier,DefaultItemLotManagementUnit, LocationPickMethodOptions, SortDirectionOptions } from "../../../../enum/TransactionDataEntryEnum";
import AutoSelectLotScreen from "../../codes/lotDataEntry/common/AutoSelectLotScreen";
import LotsSublotForShipment from "../../codes/lotDataEntry/common/LotsSublotForShipment";
import AutoSelectSublotScreen from "../../codes/lotDataEntry/common/AutoSelectSublotScreen";
import ShowDistinctItems from "./detailtabs/headerOperations/ShowDistinctItems";
import ListAvailableShipmentLotsLocations from "./detailtabs/headerOperations/ListAvailableShipmentLotsLocations";
import LotDataEntryListingPopup from "../../../../im/codes/lotDataEntry/common/LotDataEntryListingPopup";
import AutoSelectLocationPopup from "./detailtabs/headerOperations/AutoSelectLocationPopup";
import ApplyItemRateSchedule from "./detailtabs/headerOperations/ApplyItemRateSchedule";
import  ManuallySelectLotsForShipment  from "./detailtabs/headerOperations/ManuallySelectLotsForShipment";
import  ManuallySelectSublotsAndLotsForShipment  from "./detailtabs/headerOperations/ManuallySelectSublotsAndLotsForShipment";

import SublotByConsignee from "../../codes/lotDataEntry/common/SublotByConsignee";
import { populateTransactionDetailObjects } from "./common/transactionDetailUtils";
import AdjustAvailableUnAvailableStatusMainPopup from "../../common/AdjustAvailableUnAvailableStatusMainPopup";
const gridKey = "259a514f-a15a-468d-a9b6-2189e958271f";

// Sentinel returned by runLotProfileLogics when it has taken the edit over itself: it has already
// called grid.cancelEditData() and opened a popup, and the caller must not touch the cell again.
//
// Before this existed, "I took over" and "no lot to apply" were both plain null, so the callers could
// not tell them apart and ran cellElement.setValue(...) on a cell whose edit had just been cancelled.
// That re-added a pending change for a row that no longer existed, and closing the popup only flips its
// IsOpen flag - nothing clears grid state. The phantom change then sat in editing.changes until the
// next addRow(), which in cell mode flushes pending changes first: it POSTed a detail row with no item
// or lot, and the API answered 400 "One or more validation errors occurred." on a grid the operator had
// not yet typed into. Shipment-only in practice, because all four take-over branches are inside the
// shipment arm of runLotProfileLogics.
//
// Module scope on purpose: identity comparison needs one stable object, and the callers that check it
// are defined above the function that returns it.
const LOT_LOGIC_HANDLED = Object.freeze({ handled: true });

function DetailsTab(props) {
    var accessToken = props.oidc.user.access_token;
    var lotRetry = false;
    var oldLotCode = "";
    var skipLotCodeUpdate = false;
    var successLotCode = "";
    
    const [dropDownItems, setdDropDownItems] = useState(null);
    const [isNewRowActive, setIsNewRowActive] = useState(false);
    const [showDistinctItemsPopup, setShowDistinctItemsPopup] = useState(false);
    const [showListAvailableShipmentLotsLocationsPopup, setShowListAvailableShipmentLotsLocationsPopup] = useState(false);
    const [applyItemRateSchedulePopup, setApplyItemRateSchedulePopup] = useState({
        visible: false,
        itemId: null,
        lotId: null,
        headerId: null,
        detailId: null
    });    
    const [manuallySelectLotsForShipment, setManuallySelectLotsForShipment] = useState({ IsOpen: false, ItemId: null, RTransactionDetail: null });
    const [manuallySelectSublotsAndLotsForShipment, setManuallySelectSublotsAndLotsForShipment] = useState(false);

    const tabPanelRef = useRef(null);
    const subLotRef = useRef(null);
    const itemRef = useRef(null);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const [refKey, setRefKey] = useState(0);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const primaryDataGrid=useRef(null);
    const position = { of: '#accordion-containe2' };
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [selectedItemRowId, setSelectedItemRowId] = useState(null);
    const [selectedLotRowId, setSelectedLotRowId] = useState(null);
    const [selectedDetails, setSelectedDetails] = useState(null);
    const [showQuickLotEntryScreen, setShowQuickLotEntryScreen] = useState({isVisible:false,insertedLotId:null,itemCode:null});
    const [insertedLotId, setInsertedLotId] = useState(null);
    const [insertedItemcode, setInsertedItemcode] = useState(null);
    const [generateLotSerialNumbers, setGenerateLotSerialNumbers] = useState(false);
    const [showLotEntryScreen, setShowLotEntryScreen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
        const [showLotSublotEntryScreen, setShowLotSublotEntryScreen] = useState({
            IsOpen: false,
            ItemId: null,
            ShipDate: null
        });
    const [showSublotByConsigneeScreen, setShowSublotByConsigneeScreen] = useState({
        IsOpen: false,
        ConsigneeId: null
    });
   const [ShowAdjustAvailableUnavailableStatusPopup,setShowAdjustAvailableUnavailableStatusPopup] = useState({id:null,visible:false});
    const [showAutoSelectLotScreen, setShowAutoSelectLotScreen] = useState({
        IsOpen: false,
        ItemType:ItemTypes.Lot,
    });
    const [showLotDataEntryListingPopup, setShowLotDataEntryListingPopup] = useState({visible:false, title:'Select Item By Lot',module :WM,rIdentity:props.formFields.R_CUSTOMER,available:1});
    const [selectedSublots, setSelectedSublots] = useState([]);
    const [lotId, setLotId] = useState(null);
         const initialFormFields = {
             ROWID: '00000000-0000-0000-0000-000000000000',
             NETWEIGHTQUANTITY: null,
             GROSSWEIGHTQUANTITY: null,
             REFERENCE: null,
             OVERRIDESHIPDAYS: null,
             COMMENT:null,
             USERDEFINEDCOMMENT:null,
             USERDEFINEDCODE1:null,
             USERDEFINEDCODE2:null,
             USERDEFINEDCODE3:null,
             USERDEFINEDCODE4:null,
             USERDEFINEDCODE5:null,
             USERDEFINEDDATE1:null,
             USERDEFINEDDATE2:null,
             USERDEFINEDDATE3:null,
             USERDEFINEDDATE4:null,
             USERDEFINEDDATE5:null,
             USERDEFINEDQUANTITY1:null,
             USERDEFINEDQUANTITY2:null,
             USERDEFINEDQUANTITY3:null,
             USERDEFINEDQUANTITY4:null,
             USERDEFINEDQUANTITY5:null,
             USERDEFINEDREFERENCE1:null,
             USERDEFINEDREFERENCE2:null,
             USERDEFINEDREFERENCE3:null,
             USERDEFINEDREFERENCE4:null,
             USERDEFINEDREFERENCE5:null,
             RSubLot:null,
             RSubDetail:null,
         }
            const defaultItemLotManagementUnit = props.profile?.Defaultitemlotmanagementunit;
            const populateLotWithCarrier = props.profile?.Populatelotwithcarrier;
            const lotAvailableDate = props.profile?.Lotavailabledate;
    const initialPickMethods = {
        ReceivingMethodLot: props.profile?.ReceivingmethodLot,
        LotMethod: props.profile?.LotmethodShipments,
        UnitMethod: props.profile?.UnitmethodShipments,
        LocationMethod: props.profile?.LocationmethodShipments,
        SublotMethod: props.profile?.SublotmethodShipments,
        SublotPickMethod: props.profile?.SublotpickmethodShipments,
        SublotPickSeqMethod: props.profile?.SublotpicksequenceShipments,
        LotPickMethod: props.profile?.LotpickmethodShipments??ItemTypes.Lot,
        UnitPickMethod: props.profile?.UnitpickmethodShipments,
        LocationPickMethod: props.profile?.LocationpickmethodShipments??ItemTypes.Lot,
        LotPickSeqMethod: props.profile?.LotpicksequenceShipments??PickSequence.Ascending,
        UnitPickSeqMethod: props.profile?.UnitpicksequenceShipments,
        LocationPickSeqMethod: props.profile?.LocationpicksequenceShipments??PickSequence.Ascending,
        ActualQuantity:null,
        QuantityOrdered:null,
        OriginalQuantityOrder:null,
    };
    const [pickMethods, setPickMethods] = useState(initialPickMethods);
         const [formFields, setformFields] = useState(initialFormFields);
    const [autoSelectLocationsPopup, setAutoSelectLocationsPopup] = useState({
        visible: false, formFields: formFields, parentFormFields: props.formFields, profile: props.profile, pickMethods: pickMethods,
        setLoadPanelVisible: setLoadPanelVisible, detailGrid: props.detailGrid, primaryDataGrid: primaryDataGrid, subDetail: subLotRef.current ?? null
    });
    const uomArray = [
        {
            flagvalue: "I",
            flagdescription: "Inventory Units"
        },
        {
            flagvalue: "P",
            flagdescription: "Pieces"
        },
        {
            flagvalue: "K",
            flagdescription: "Packages"
        },
        {
            flagvalue: "H",
            flagdescription: "Shipments"
        }
    ];

    const setSelectedSubLot=(selectedSubLot) => {
        if(selectedSubLot)
            subLotRef.current = selectedSubLot;
    }
    const RefereshGrid = () =>{
        if (
            props &&
            props.detailGrid &&
            props.detailGrid.current &&
            props.detailGrid.current.instance &&
            typeof props.detailGrid.current.instance().refresh === 'function'
          ) {
            props.detailGrid.current.instance().refresh();
          }
    }
    // createConcurrencyAwareStore, not createStore: grids issue their own requests and never pass through
    // axios, so the global interceptor never sees them and a 409 would land as a bare DevExtreme error row
    // with no dialog — and the rejected edit would sit in `editing.changes` to be re-saved by any click that
    // closes the cell. The accessToken second argument is deliberately OMITTED (see dataStore.js:81-83):
    // the onBeforeSend below replaces `ajaxOptions.headers` wholesale, so injected headers would be dropped.
    const dataSource = useMemo(() => createConcurrencyAwareStore({
        onConflict: refreshGridOnConflict(props.detailGrid, props.changeTotals),
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTransactionDetails}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${data.Transaction.InsertTransactionDetail}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${data.Transaction.UpdateTransactionDetail}`,
        loadParams: {
            transactionRowId: props.formFields.ROWID
        },
        // Auth headers only. The RSubDetail/RSubLot stamping that used to rebuild `ajaxOptions.data.values`
        // here moved to onRowUpdating, per rule 15 — the standard form-encoded protocol stays untouched.
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
            };
        },
        onInserted:function(e){
           
            var lotid = e?.lotId;
            setInsertedLotId(lotid);
            var itemcode = e?.itemCode;
            setInsertedItemcode(itemcode);
            props.setIsLineItemExist(true);
        },
        onUpdated: function (key, updatedValues) {
            setRefKey(prev => prev + 1);
        }
        
         
    }), [props.formFields.ROWID]);  // Recreate when ROWID changes

    const deleteRecords = () => {

        let result = confirm("<i>Delete selected record?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                props.detailGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${data.Transaction.DeleteTransactionDetails}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        props.detailGrid.current.instance().endCustomLoading();
                        props.detailGrid.current.instance().refresh();
                        props.changeTotals();
                    })
                    .catch((err) => {
                        props.detailGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });

            }
        });

    }
    const handleFormSubmit = async () => {
        
        try {
            setLoadPanelVisible(true);
            let fields = formFields;
            fields.USERDEFINEDDATE1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE1);
            fields.USERDEFINEDDATE2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE2);
            fields.USERDEFINEDDATE3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE3);
            fields.USERDEFINEDDATE4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE4);
            fields.USERDEFINEDDATE5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE5);
            fields.RSubDetail= subLotRef.current.rowid;
            fields.RSubLot=subLotRef.current.rSublot;
            var response = await axios.post
                (
                    `${window._env_.REACT_APP_APIS}/${data.Transaction.UpdateTransactionDetailByRowId}`,
                    fields,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                );
            if (response.status===200) {

                notify(
                    {
                        message: "Transaction Updated",
                        width: 300,
                    },
                    'success',
                    3000,
                );
                RefereshGrid();
            } else {
                notify(
                    {
                        message: 'Error submitting form:' + response.data.message,
                        width: 600,
                    },
                    'error',
                    3000,
                );
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            // UpdateTransactionDetailByRowId used to roll back and still answer 200, so a failed update
            // showed the green "Transaction Updated" toast. It now throws, and this catch only logged —
            // which would have made the failure silent instead.
            if (!error?.[CONCURRENCY_HANDLED]) {
                notify({ message: getApiErrorMessage(error, MESSAGES.ERROR), width: 600 }, 'error', 3000);
            }
        } finally {
            hideLoadPanel();

        }
    };
    const onSelectionChanged = (e) => {
        if (selectedDetails?.itemType === 'S') {
            setSelectedTabIndex(1);  
          }else{
            setSelectedTabIndex(0); 
          }
        setSelectedItemKeys(e.selectedRowKeys);
        // Reset new row active state when selection changes to an existing row
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setIsNewRowActive(false);
            setSelectedItemRowId(e.selectedRowsData[0].itemId);
            setSelectedLotRowId(e.selectedRowsData[0].lotId);
            setSelectedDetails(e.selectedRowsData[0]);
            let row=e.selectedRowsData[0];
            setformFields(prevFields => ({
                ...prevFields,
                ROWID: row.rowid,
                NETWEIGHTQUANTITY: row.netWeightQuantity,
                GROSSWEIGHTQUANTITY: row.grossWeightQuantity,
                REFERENCE: row.reference,
                OVERRIDESHIPDAYS: row.overrideShipDays,
                DETAILSTATUS:row.detailStatus,
                COMMENT:row.comment,
                USERDEFINEDCOMMENT:row.userDefinedComment,
                USERDEFINEDCODE1:row.code1,
                USERDEFINEDCODE2:row.code2,
                USERDEFINEDCODE3:row.code3,
                USERDEFINEDCODE4:row.code4,
                USERDEFINEDCODE5:row.code5,
                USERDEFINEDDATE1:row.date1,
                USERDEFINEDDATE2:row.date2,
                USERDEFINEDDATE3:row.date3,
                USERDEFINEDDATE4:row.date4,
                USERDEFINEDDATE5:row.date5,
                USERDEFINEDQUANTITY1:row.quantity1,
                USERDEFINEDQUANTITY2:row.quantity2,
                USERDEFINEDQUANTITY3:row.quantity3,
                USERDEFINEDQUANTITY4:row.quantity4,
                USERDEFINEDQUANTITY5:row.quantity5,
                USERDEFINEDREFERENCE1:row.reference1,
                USERDEFINEDREFERENCE2:row.reference2,
                USERDEFINEDREFERENCE3:row.reference3,
                USERDEFINEDREFERENCE4:row.reference4,
                USERDEFINEDREFERENCE5:row.reference5,
            }));
        }
    }
    
    const onRowUpdated = (e) => {
        successLotCode = "";
        skipLotCodeUpdate = false;
        // selectedDetails is the snapshot taken when the row was selected, and nothing else refreshed
        // it. The grid edits in cell mode and commits on cell exit, so the snapshot went stale the
        // moment the user changed a value - which is why clearing the Lot still tripped the "already
        // has a Lot Code" guard on the Manually Select Lots / Sublots options. Everything else reading
        // selectedDetails (the child tabs, the Operations menu builder) was equally stale.
        const isSelectedRow = selectedDetails && selectedDetails.rowid === e.key;
        if (isSelectedRow) {
            const live = e.component?.getVisibleRows?.().find((r) => r.key === e.key)?.data;
            const merged = { ...selectedDetails, ...(live ?? {}), ...(e.data ?? {}) };
            setSelectedDetails(merged);
            // These two are derived from the same row and were captured alongside it, so they went
            // stale with it - the manual-selection popups take their ItemId from selectedItemRowId.
            setSelectedItemRowId(merged.itemId);
            setSelectedLotRowId(merged.lotId);
        }
        props.changeTotals();
    };

    const onRowInserted = (e) => {
        props.changeTotals();
        if(props.detailGrid.current.instance)
          props.detailGrid.current.instance().selectRows([e.key], true); 
        e.component.columnOption('keySequence', {  
            sortOrder: 'asc',  
            sortIndex: 0  
          });
        setIsNewRowActive(false);
        successLotCode = "";
        skipLotCodeUpdate = false;
    };

    const rowInserting=(e)=> {
        e.data['rTransactionheader'] = props.formFields.ROWID;

        e.data['RecordType'] =props.formFields.RECORDTYPE;
        e.data['HeaderRowId'] = props.formFields.ROWID;
        e.data['TransactionType'] = props.formFields.TRANSACTIONTYPE;
        e.data['FromStage'] = TransactionTypes.Invoice;
        e.data['Stage'] = props.formFields.STAGE;
        e.data['DetailRowId'] =formFields.ROWID;
        e.data['SubDetailRowId'] = null;
        e.data['DefaultReceiptWH'] = null;
        e.data['ReceiptLocationMethod'] = props.profile?.LocationmethodReceipts;
        e.data['LocationMethod'] = pickMethods.LocationMethod??MethodShipments.AutoSelect;
        e.data['LocationPickMethod'] = pickMethods.LocationPickMethod; //m
        e.data['LocationPickSequence'] = pickMethods.LocationPickSeqMethod; //seq
        e.data['LotMethod'] = pickMethods.LotMethod??MethodShipments.Manual;
        e.data['LotPickMethod'] = pickMethods.LotPickMethod??LotPickMethodShipments.LotCode;
        e.data['LotPickSequence'] = pickMethods.LotPickSeqMethod;
        e.data['SublotMethod'] = pickMethods.SublotMethod;
        e.data['SublotPickMethod'] = pickMethods.SublotPickMethod??SublotPickMethodShipments.SublotCode;
        e.data['SublotPickSequence'] = pickMethods.SublotPickSeqMethod??PickSequence.Ascending;
        e.data['UnitMethod'] = pickMethods.UnitMethod;
        e.data['UnitPickMethod'] =pickMethods.UnitPickMethod??UnitPickMethodShipments.UnitCode;
        e.data['UnitPickSequence'] =pickMethods.UnitPickSeqMethod??PickSequence.Ascending;
        e.data['ShipmentsOnNegAvl'] = props.profile?.ShipmentsonnegAvl??ShowMasterLot.None;
        e.data['Mode'] =ShowMasterLot.None;

        e.data['ActualQuantity'] = pickMethods.ActualQuantity;
        e.data['QuantityOrdered'] = pickMethods.QuantityOrdered;
        e.data['OriginalQuantityOrder'] = pickMethods.OriginalQuantityOrder;

        
        successLotCode = "";
        skipLotCodeUpdate = false;
    }
    const onInitNewRow = (e) => {
        successLotCode = "";
        skipLotCodeUpdate = false;
        e.data["inventoryUomFlag"] = "I";
        if(selectedRow)
        {
            e.data["itemId"]= selectedRow.ItemId;
            e.data["lotId"]= selectedRow.RowId;
            e.data["lotCode"]= selectedRow.LotCode;
            e.data["itemCode"]= selectedRow.ItemCode;
        }

        props.detailGrid.current.instance().clearSelection();
        setSelectedLotRowId('00000000-0000-0000-0000-000000000000');
        setSelectedDetails(e.data);
        setIsNewRowActive(true);
        if (tabPanelRef.current) {
            tabPanelRef.current.instance().option("selectedIndex", 0);
        }
    };

    const onEditingStart = (e) => {
        if(e.key != null && e.key != undefined && !props.detailGrid.current.instance().isRowSelected(e.key))
        {
            props.detailGrid.current.instance().selectRows([e.key], false);
        }
    };
    const onEditorPreparing = (e) => {
    };
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();  
            if(selection.length == 0) {  
                e.component.selectRowsByIndexes([0]);  
            }
        }  
    };

    const onEditCanceled = (e) => {
        var selection = e.component.getSelectedRowKeys();  
        if(selection.length == 0) {  
            e.component.selectRowsByIndexes([0]);  
        }
        setIsNewRowActive(false);
        successLotCode = "";
        skipLotCodeUpdate = false;
    };

    const onRowUpdating = (e) => {

        successLotCode = "";
        skipLotCodeUpdate = false;

        // Rule 15: stamp what the request needs here rather than rewriting the body in onBeforeSend.
        //
        // Copy NAMED FIELDS ONLY — deliberately NOT `{ ...e.oldData, ...e.newData }`. In cell edit mode
        // e.newData holds just the changed cell; a full merge would make `inventoryUomFlag` always present,
        // so the "You have changed the Transaction Units" confirm below would fire on EVERY cell edit of
        // EVERY row. It would also widen what PopulateObject/FillEntityFromDTO writes from one column to the
        // whole row, over server-computed columns. Architecture.md sanctions the named-field copy for older
        // WM grids for exactly this reason.
        if (e.newData) {
            // The version the user was editing. Without this the server's token derives from the row's own
            // current value and the concurrency check passes against itself — i.e. silently fails open.
            if (!('concurrencyToken' in e.newData) && e.oldData) {
                e.newData.concurrencyToken = e.oldData.concurrencyToken;
            }

            // Moved out of onBeforeSend. Load-bearing: the service reads RSubLot/RSubDetail to decide
            // whether to auto-create serial-number records for sub-lot items, so dropping them would
            // silently stop serial creation rather than fail.
            if (subLotRef.current) {
                e.newData.RSubDetail = subLotRef.current.rowid;
                e.newData.RSubLot = subLotRef.current.rSublot;
            }
        }

        if(e.newData && e.newData.inventoryUomFlag)
        {
            const isCanceled = new Promise((resolve, reject) => {
                const promptPromise = confirm("You have changed the Transaction Units. Do you wish to continue?", "Confirm Field Update");
                promptPromise.then((dialogResult) => {
                    if (dialogResult) 
                    {
                        resolve(false);
                    } else 
                    {
                        props.detailGrid.current.instance().cancelEditData();
                        return resolve(true);
                    }
                });
            });

            e.cancel = isCanceled;
        }
    };
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);  
    useEffect(() => {
        if (selectedDetails?.itemType === 'S') {
            setSelectedTabIndex(1);  
          }else{
            setSelectedTabIndex(0); 
          }
    }, [selectedDetails?.itemType]);  
        useEffect(() => {
        if (lotId) {
        setShowLotEntryScreen(true);
          }
    }, [lotId]);  
    const handleTabSelectionChange = (e) => {
      setSelectedTabIndex(e.addedIndex);  
    };
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);

    const validationCanceled = useRef(false);

    const ValidateTransactionDetailLineItemWarnings = (e) => {
        
        if( (e.newData?.lotCode != undefined && e.newData?.lotCode != null && 
            e.newData?.lotId != undefined && e.newData?.lotId != null) && 
            (e.newData?.lotCode === "[LOTVALIDATIONFAILED]" || e.newData?.lotCode === "[RETYPELOTCODE]"|| e.newData?.lotCode === e.newData?.lotId))
        {
            e.isValid = false;
            e.errorText = "Please enter a valid lot.";
            return;
 
        }

        const row = { ...e.oldData, ...e.newData };
        const lot  = row.lotCode?.trim();
        const type = row.type;
        var receivingmethodLot = props.profile?.ReceivingmethodLot;

        // Carve-out: a line carrying no quantity at all (ordered 0 and shipped 0/null) may be saved
        // without a lot, matching the server rule in
        // TransactionDetailService.ValidateTransactionDetailLineItemErrors. It lets a placeholder detail
        // line be entered before its lot is known.
        //
        // `??` rather than the `?:` truthiness chain used further down: editing Ordered from 5 to 0 puts
        // a genuine 0 in newData, and a truthiness test would discard it and read 5 back off oldData.
        //
        // Relaxing this loses no legacy coverage. Delphi had no lot-mandatory rule at detail entry at
        // all — the requirement was deferred to the stage change into Completed, where TransactionIsValid
        // (uWMD0002.pas:9121-9150) blocked any ItemType 'L'/'S'/'U' line with a null lot/sublot/unit.
        // That rule is ported and now runs server-side on the stage-change gate, so a missing lot is
        // still caught before the transaction can complete. This detail-entry check is a web-only
        // addition (DEV-5572) and is stricter than both Delphi and the API.
        const orderedQty = row.quantityordered ?? 0;
        const shippedQty = row.actualQuantity  ?? 0;
        const isEmptyQuantityLine = Number(orderedQty) === 0 && Number(shippedQty) === 0;

        // Literals replaced with the enums this file already imports: ItemTypes (:25),
        // TransactionTypes (:25), ReceivingMethodLot for the serial-sequential flag.
        if (type !== ItemTypes.Item && (!lot || lot === "") && receivingmethodLot != ReceivingMethodLot.Sequential && !isEmptyQuantityLine)  // If not inventory type and lot is empty and receiving method is not serial, and the line carries a quantity
        {
            e.isValid = false;
            e.errorText = "Please enter a lot.";
            return;
        }

        var showOversellingWarning = false;
        if(props.profile?.Oversellingwarning === 'Y' && props?.formFields?.TRANSACTIONTYPE === 'S' && props?.formFields?.STATUS !== 'Z' && (props?.formFields?.STAGE === 'R' || props?.formFields?.STAGE === 'C')) 
        {
            showOversellingWarning = true;
        }

        if (validationCanceled.current) {
            validationCanceled.current = false;  
            return;
        }

        
        e.promise = new Promise(async (resolve) => {
            var actualQuantity;
            var quantityordered;

            if(showOversellingWarning)
            {
                actualQuantity = e.newData?.actualQuantity ? e.newData?.actualQuantity : e.oldData?.actualQuantity ? e.oldData?.actualQuantity : 0;
                quantityordered = e.newData?.quantityordered ? e.newData?.quantityordered : e.oldData?.quantityordered ? e.oldData?.quantityordered : 0;
                if (actualQuantity > quantityordered) 
                {
                    let result = await confirm("<i>Actual Quantity Entered GREATER than Ordered. Do you wish to Continue?</i>", "Confirmation");
                    if(!result)
                    {
                        e.isValid = false;
                        validationCanceled.current = true;
                        return resolve();
                    }
                    else
                    {
                        e.isValid = true;
                        return resolve();
                    }
                }
            }

            var duplicatelotProfileSetting = props.profile?.Duplicatelot;
            if (!duplicatelotProfileSetting || !['W', 'C'].includes(duplicatelotProfileSetting)) {
                return resolve();
            }

            var receivingmethodLot = props.profile?.ReceivingmethodLot;
            if(receivingmethodLot == "S")
            {
                return resolve();
            }
            
            const itemId = e.newData?.itemId;
            const itemCode = e.newData?.itemCode;
            const lotId = e.newData?.lotId;
            actualQuantity = e.newData?.actualQuantity ?? 0;
            quantityordered = e.newData?.quantityordered ?? 0;
            const payload = {
                headerId: props.formFields.ROWID,
                lotCode: lot,
                itemId: itemId,
                lotId: lotId,
                actualQuantity: actualQuantity,
                quantityordered: quantityordered,
                itemCode: itemCode,
            };
            try {
                const res = await axios.post(
                    `${window._env_.REACT_APP_APIS}/wm/TransactionDetail/ValidateTransactionDetailLineItemWarnings`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                );
                if (res.data.issuccess) {
                    return resolve();
                }
                if (res.data.iswarning) {
                    const warningText = formatErrorList(res.data.errors, ERROR_SEVERITY.WARNING) || "Confirm";
                    confirm(warningText, "Confirm").done(result => {
                        if (!result) {
                            e.isValid = false;
                            e.errorText = warningText;
                            validationCanceled.current = true;
                            setTimeout(() => {
                                const gridInstance = e.component;
                                gridInstance.cancelEditData();
                            });
                        } else {
                            e.isValid = true;
                        }
                        resolve();
                    });
                } else {
                    const errorText = formatErrorList(res.data.errors, ERROR_SEVERITY.ERROR);
                    e.isValid = false;
                    alert(errorText, "Error");
                    e.errorText = errorText;
                    validationCanceled.current = true;
                    setTimeout(() => {
                        const gridInstance = e.component;
                        gridInstance.cancelEditData();
                    });
                    resolve();
                }
    
            } catch (error) {
                console.error("Validation error:", error);
                e.isValid = false;
                e.errorText = "Server validation error.";
                resolve();
            }
        });
    };
    useEffect(() => {
        if (props.formFields)
            setActionDropDownItems();
    }, [props.formFields,selectedDetails]);
    const openAutoSelectLocationsPopup = () => {
        setAutoSelectLocationsPopup({visible:true,formFields:formFields,parentFormFields:props.formFields, profile:props.profile,pickMethods:initialPickMethods,
            setLoadPanelVisible:setLoadPanelVisible,detailGrid:props.detailGrid,primaryDataGrid:primaryDataGrid,locationDataGridRef:props.locationDataGridRef,subDetail: subLotRef.current ?? null});
    }
    const setActionDropDownItems = () => {
        const isAutoSelectLocationVisible = props?.formFields?.TRANSACTIONTYPE === LocationStatus.ShipmentsOnly &&
            (props?.formFields?.STAGE === TransactionStage.Ready || props?.formFields?.STAGE === TransactionStage.Completed) &&
            (selectedDetails?.itemType === ItemTypes.Item || selectedDetails?.itemType === ItemTypes.Lot);
        const isSerialNumberVerificationVisible = props?.formFields?.STATUS !== Statuses.History 
            && (props?.formFields?.TRANSACTIONTYPE === TransactionTypes.Shipment || props?.formFields?.TRANSACTIONTYPE === TransactionTypes.Receipt)
            && (selectedDetails?.shipselection === Options.Yes || selectedDetails?.shipselection === ShipSelection.UserDefined);
        var items = Object.entries(WMTransactionDetailsOptions)
            .filter(([key, value]) => {
                if (value === WMTransactionDetailsOptions.AutoSelectLocation && isAutoSelectLocationVisible) return false;
                if( value === WMTransactionDetailsOptions.SelectByLot && props?.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment)
                    return false;
                if( value === WMTransactionDetailsOptions.SetSerialNumberVerification && !isSerialNumberVerificationVisible)
                    return false;
                // Apply Item Rate Schedule should only be visible if transaction type is Shipment, stage is Completed, and profile ACCESSRATESCHEDULE is Y
                if( value === WMTransactionDetailsOptions.ApplyItemRateSchedule && (props?.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment || props?.formFields?.STAGE !== TransactionStage.Completed || props?.profile?.Accessrateschedule !== Options.Yes))
                    return false;
                if( value === WMTransactionDetailsOptions.SelectSublotsByConsignee && props?.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment)
                    return false;
                // Delphi hides Show Distinct Items unless the transaction is uncommitted, a Receipt or
                // an Adjustment, and not a Plan record (uWMD0002.pas:17506-17512). Visibility only -
                // enablement is handled separately, see ROW_INDEPENDENT_OPERATIONS.
                if( value === WMTransactionDetailsOptions.ShowDistinctItems &&
                    !(props?.formFields?.STATUS !== TransactionStatus.Committed
                      && (props?.formFields?.TRANSACTIONTYPE === TransactionTypes.Receipt
                          || props?.formFields?.TRANSACTIONTYPE === TransactionTypes.Adjustment)
                      && props?.formFields?.RECORDTYPE !== TransactionStageEnum.Plan))
                    return false;
                if( value === WMTransactionDetailsOptions.AdjustAvailableUnAvailableStatus && props?.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment)
                    return false;
                return true;
            })
            .map(([key, value]) => {
                if (value === WMTransactionDetailsOptions.ManuallySelectLotsForShipment) {
                    if (props?.formFields?.ROWID && props?.formFields?.ROWID !== "00000000-0000-0000-0000-000000000000" && 
                        props?.formFields?.TRANSACTIONTYPE === TransactionTypes.Shipment &&
                        (props?.formFields?.STAGE === TransactionStage.Ready || props?.formFields?.STAGE === TransactionStage.Completed)) 
                    {
                        return { id: key, name: value };
                    }
                    else
                    {
                        return { id: key, name: value, disabled: true };
                    }
                }

                if (value === WMTransactionDetailsOptions.ManuallySelectLotsAndSublotsForShipment) {
                    if (props?.formFields?.ROWID && props?.formFields?.ROWID !== "00000000-0000-0000-0000-000000000000" && 
                        props?.formFields?.TRANSACTIONTYPE === TransactionTypes.Shipment &&
                        (props?.formFields?.STAGE === TransactionStage.Ready || props?.formFields?.STAGE === TransactionStage.Completed)) 
                    {
                        return { id: key, name: value };
                    }
                    else
                    {
                        return { id: key, name: value, disabled: true };
                    }
                }
                
                return { id: key, name: value };
            });
        setdDropDownItems(items);
    }
    // The Operations guards must validate what the row actually holds, not what it held when it was
    // selected. Commits anything still pending first, so a value the user just typed is not silently
    // discarded (the old code called cancelEditData() AFTER validating, throwing the edit away).
    // Returns null when the row cannot be resolved or the pending edit was refused - callers abort.
    const resolveSelectedDetailRow = async () => {
        const grid = props.detailGrid?.current?.instance?.();
        if (!grid) return selectedDetails;

        if (grid.hasEditData()) {
            try {
                await grid.saveEditData();
            } catch (error) {
                console.error(error);
                return null;
            }
            // Server-side validation refused the change; it is still pending, so do not carry on.
            if (grid.hasEditData()) return null;
        }

        const live = grid.getSelectedRowsData?.() ?? [];
        return live.length ? live[0] : selectedDetails;
    };

    const onItemClick = async (e) => {
        let name = e.itemData?.name;
        if (name === WMTransactionDetailsOptions.AutoSelectLocation) {
                openAutoSelectLocationsPopup();
                return;
        }
        else if (name === WMTransactionDetailsOptions.CancelLineItems) { 
            await cancelLineItems();
            return;
        } 
            else if (name === WMTransactionDetailsOptions.GenerateLotSerialNumbers) { 
            setGenerateLotSerialNumbers(true);
            return;
        }
        else if (name === WMTransactionDetailsOptions.DeleteItemChargesForSelectedItem) {
            await deleteItemChargesForSelectedItem();
            return;
        }
        else if (name === WMTransactionDetailsOptions.DeleteItemChargesForAllItems) {
            await deleteItemChargesForAllItems();
            return;
        }
        else if (name === WMTransactionDetailsOptions.ShowDistinctItems) {
            // Release the grid's focus before the popup opens, or the pending edit swallows it.
            const gridInstance = props.detailGrid.current.instance();
            if (gridInstance && gridInstance.hasEditData()) {
                gridInstance.cancelEditData();
            }
            setTimeout(() => {
                setShowDistinctItemsPopup(true);
            }, 100);
            return;
        }
        else if  (name === WMTransactionDetailsOptions.DeleteSerialNumber){
            DeleteSerialNumbersForSubLot();
            return;
        }
        else if (name === WMTransactionDetailsOptions.SelectByLot) {
            setShowLotDataEntryListingPopup({visible:true, title:'Select Item By Lot',module :WM,rIdentity:props.formFields.R_CUSTOMER,available:1});
            return;
        }
        else if (name === WMTransactionDetailsOptions.ListAvailableLotsLocationsForShipment) {
            // Cancel any pending edit in the grid to release focus
            const gridInstance = props.detailGrid.current.instance();
            if (gridInstance && gridInstance.hasEditData()) {
                gridInstance.cancelEditData();
            }
            // Use setTimeout to ensure the edit is canceled before opening popup
            setTimeout(() => {
                setShowListAvailableShipmentLotsLocationsPopup(true);
            }, 100);
            return;
        }
        else if (name === WMTransactionDetailsOptions.ListAvailableLotsLocationsForShipment) {
            // Cancel any pending edit in the grid to release focus
            const gridInstance = props.detailGrid.current.instance();
            if (gridInstance && gridInstance.hasEditData()) {
                gridInstance.cancelEditData();
            }
            // Use setTimeout to ensure the edit is canceled before opening popup
            setTimeout(() => {
                setShowListAvailableShipmentLotsLocationsPopup(true);
            }, 100);
            return;
        }
        else if (name === WMTransactionDetailsOptions.SetSerialNumberVerification) {
            SerialNumberVerification();
            return;
        }
        else if (name === WMTransactionDetailsOptions.ApplyItemRateSchedule) {
            let result = confirm("<i>DELETE Existing Item Charges For This Line Detail & Re-Create Charges Based On Selected Rate Schedule?</i>", "Confirm");
            result.then((dialogResult) => {
                if (dialogResult) {
                    setApplyItemRateSchedulePopup({ 
                        visible: true,
                        itemId: selectedItemRowId,
                        lotId: selectedLotRowId,
                        headerId: props.formFields.ROWID,
                        detailId: selectedItemKeys.length > 0 ? selectedItemKeys[0] : null
                    });
                }
            });
            return;
        }
        else if (name === WMTransactionDetailsOptions.ManuallySelectInventoryForShipment) {
            await ManuallySelectInventoryForShipment();
            return;
        }
        else if (name === WMTransactionDetailsOptions.SelectSublotsByConsignee) {
            setShowSublotByConsigneeScreen({IsOpen:true,ConsigneeId:props.formFields.R_CONSIGNEE});
            return;
        }
        else if (name === WMTransactionDetailsOptions.ManuallySelectLotsForShipment)
        {
            if (props.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment) {
                alert("Transaction Type Must Be a 'Shipment' in Order to Use This option.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // Validate the row as it now stands, committing any uncommitted cell first.
            const detailRow = await resolveSelectedDetailRow();
            if (!detailRow) return;

            // 2) An item must be entered
            if (!detailRow?.itemCode) {
                alert("Please Enter the Item Code before proceeding OR If Item Code has been Entered Press the TAB KEY to Refresh the Control before proceeding", "Information");
                return;
            }

            // 3) Item type must be Lot
            if (detailRow?.itemType !== ItemTypes.Lot) {
                alert("Item Type Must be 'Lot' in Order to Use This option.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // 4) Lot must be blank on this line
            if (detailRow?.lotCode || detailRow?.lotId) {
                alert("This Line Item Record Already Have a Lot Code Assigned - Cannot Use This Option", "Information");
                return;
            }

            // 5) Transaction unit must be Inventory
            if (detailRow?.inventoryUomFlag !== WMSInventoryUOMFlag.Inventory) {
                alert("Transaction Unit in the Detail MUST be set to 'Inventory' in Order to Use This option.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // 6) Item must have available qty
            const available = Number(detailRow?.itemAvailable ?? 0);
            if (!(available > 0)) {
                alert("This Item Does Not have any Available Quantity to Ship.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // 7) Stage must be Ready or Completed
            if (!(props.formFields?.STAGE === TransactionStage.Ready || props.formFields?.STAGE === TransactionStage.Completed)) {
                alert("Transaction Stage Must Be a 'Ready' or 'Completed' in Order to Use This option.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // 8) Open the manual selection popup (WMD0107, item level 'L')
            setManuallySelectLotsForShipment({
                IsOpen: true,
                ItemId: selectedItemRowId,
                RTransactionDetail: selectedItemKeys[0],
            });

            return;
        }
        else if (name === WMTransactionDetailsOptions.ManuallySelectLotsAndSublotsForShipment) 
        {
            if (props.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment) {
                alert("Transaction Type Must Be a 'Shipment' in Order to Use This option.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // Validate the row as it now stands, committing any uncommitted cell first.
            const detailRow = await resolveSelectedDetailRow();
            if (!detailRow) return;

            // 2) An item must be entered
            if (!detailRow?.itemCode) {
                alert("Please Enter the Item Code before proceeding OR If Item Code has been Entered Press the TAB KEY to Refresh the Control before proceeding", "Information");
                return;
            }

            // 3) Item type must be Sublot
            if (detailRow?.itemType !== ItemTypes.SubLot) {
                alert("Item Type Must be 'Sublot' in Order to Use This option.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // 4) Lot must be blank on this line. Both fields are tested: clearing the Lot cell writes
            // lotCode = "" and lotId = null together (the column's setCellValue), so a row with only
            // one of them set means the pair got out of step and the detail still carries R_LOT.
            if (detailRow?.lotCode || detailRow?.lotId) {
                alert("This Line Item Record Already Have a Lot Code Assigned - Cannot Use This Option", "Information");
                return;
            }

            // 5) Transaction unit must be Inventory
            if (detailRow?.inventoryUomFlag !== WMSInventoryUOMFlag.Inventory) {
                alert("Transaction Unit in the Detail MUST be set to 'Inventory' in Order to Use This option.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // 6) Item must have available qty
            const available = Number(detailRow?.itemAvailable ?? 0);
            if (!(available > 0)) {
                alert("This Item Does Not have any Available Quantity to Ship.<br/>Click OK to Exit From This Screen", "Information");
                return;
            }

            // 8) Open the manual selection popup
            setManuallySelectSublotsAndLotsForShipment(true);
            // setShowLotSublotEntryScreen({ IsOpen: true, ItemId: selectedDetails?.itemId, ShipDate: props.formFields.ACTUALRECEIVEDSHIPPEDDATETIME?? props.formFields.TRANSACTIONDATE });

            return;
        }
        else if (name === WMTransactionDetailsOptions.AdjustAvailableUnAvailableStatus) {
            setShowAdjustAvailableUnavailableStatusPopup({id:selectedItemRowId,visible:true});
            return;
        }
        else if (name === WMTransactionDetailsOptions.ShowShippingInformation) {
            // Was opening the Adjust Available/Unavailable popup — a copy/paste of the branch above.
            // Shipping Information is handled on the header (form.js), not from the details grid.
            alert(MESSAGES.FUNCTIONALITY_UNDER_CONSTRUCTION, MESSAGES.INFORMATION);
            return;
        }
    }
    const ManuallySelectInventoryForShipment = async () => {
        // Validation 1: Transaction Type must be 'S' (Shipment)
        if (props.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment) {
            alert(MESSAGES.SHIPMENT_TYPE_REQUIRED, MESSAGES.INFORMATION);
            return;
        }

        // Validate the row as it now stands, committing any uncommitted cell first.
        const detailRow = await resolveSelectedDetailRow();
        if (!detailRow) {
            // A pending edit that was refused has already surfaced its own error, so only the
            // genuinely-no-selection case needs a message here.
            if (!props.detailGrid?.current?.instance?.()?.hasEditData?.()) {
                alert(MESSAGES.SELECT_TRANSACTION_DETAIL_ROW, MESSAGES.INFORMATION);
            }
            return;
        }

        // Validation 2: Item Code must be entered
        if (!detailRow.itemId || (typeof detailRow.itemId === 'string' && detailRow.itemId.trim() === '')) {
            alert(MESSAGES.ENTER_ITEM_CODE_OR_REFRESH_CONTROL, MESSAGES.INFORMATION);
            return;
        }

        // Validation 3: Item Type must be 'S' (Sublot)
        if (detailRow?.itemType !== ItemTypes.SubLot) {
            alert(MESSAGES.SUBLOT_TYPE_REQUIRED, MESSAGES.INFORMATION);
            return;
        }

        // Validation 4: Lot Code must not already be assigned. The old test only fired for a non-blank
        // STRING lotId, so a Guid-typed or cleared-to-null value slipped through in one direction and a
        // stale lotCode slipped through in the other; both fields are now tested for any truthy value.
        if (detailRow?.lotId || detailRow?.lotCode) {
            alert(MESSAGES.ALREADY_HAS_LOT_CODE, MESSAGES.INFORMATION);
            return;
        }

        // Validation 5: Transaction Unit must be 'Inventory'
        if (detailRow?.inventoryUomFlag !== WMSInventoryUOMFlag.Inventory) {
            alert(MESSAGES.INVENTORY_UNIT_REQUIRED, MESSAGES.INFORMATION);
            return;
        }

        // Validation 6: Item must have available quantity > 0
        const itemAvailable = parseFloat(detailRow?.itemAvailable);
        if (!(itemAvailable > 0)) {
            alert(MESSAGES.NO_AVAILABLE_QUANTITY_TO_SHIP, MESSAGES.INFORMATION);
            return;
        }
        // Validation 7: Transaction Stage must be 'R' (Ready) or 'C' (Completed)
        const stage = props.formFields?.STAGE;
        if (stage !== TransactionStage.Ready && stage !== TransactionStage.Completed) {
            alert(MESSAGES.READY_OR_COMPLETED_STAGE_REQUIRED, MESSAGES.INFORMATION);
            return;
        }

        // All validations passed - open the lot/sublot selection screen
        setManuallySelectSublotsAndLotsForShipment(true);
    }

    const SerialNumberVerification = () => {

    const updateUrl = "wm/Serialnumber/SetSerialNumberVerification";
    if (!selectedItemKeys || !selectedItemKeys.length) {
        alert(MESSAGES.NO_RECORD_FOUND_RANGE, MESSAGES.ERROR);
        return;
    }
    setLoadPanelVisible(true);
    axios.post(
        `${window._env_.REACT_APP_APIS}/${updateUrl}`,
        {
            RIndetail: selectedItemKeys[0],
            ROutdetail: selectedItemKeys[0],
            Receiptverified: YesNo.Yes,
            Shipmentverified: YesNo.Yes,
            Recordtype: props.formFields.TRANSACTIONTYPE
        },
        {
            headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
            },
        }
    )
    .then(res => {
        if (res.data && res.data.success) {
            notify({ message: MESSAGES.SERIAL_NUMBER_VERIFICATION_UPDATE_SUCCESS, width: 300 }, 'success', 3000);
            RefereshGrid && RefereshGrid();
        } else {
            alert(res.data.message, MESSAGES.ERROR);
        }
    })
    .catch(err => {
        alert(err?.response?.data?.message , MESSAGES.ERROR);
    }).finally(()=>setLoadPanelVisible(false));
    }
    const DeleteSerialNumbersForSubLot = () => {
        var deleteUrl = "wm/Serialnumber/DeleteSerialNumbersByDetail";
        let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedItemKeys[0],
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                     if(res.data.success){
                        notify({message: MESSAGES.DELETE_SUCCESS, width: 100,},'success',3000);
                     }
                     else{
                        alert(res.data.message, MESSAGES.ERROR);
                     }
                    })
                    .catch((err) => {
                        alert(err, MESSAGES.ERROR);
                    });
            }
        });
    };

    /** Options exempt from the "needs a selected row" rule. Almost every entry acts ON the current
     *  detail line, so it is disabled without one; Show Distinct Items instead exists to ADD a line,
     *  and greying it out would kill it exactly when it is wanted - nothing selected, about to add.
     *
     *  Deliberately NOT a copy of Delphi here. Delphi leaves the entry clickable too, but then refuses
     *  at click time unless the detail dataset is already in dsInsert, with "You must be entering a new
     *  line detail to use this option" (opShowDistinctItemsClick, uWMD0002.pas:18251-18255). That guard
     *  does not carry over: it exists because Delphi pastes the chosen item code into the row you are
     *  part-way through inserting, whereas handleDistinctItemSelected below adds the grid row itself
     *  when there isn't one. Reproducing the refusal would just block a case the web handles.
     *
     *  Emptying this Set makes Show Distinct Items grey out with the rest when no row is selected. */
    const ROW_INDEPENDENT_OPERATIONS = useMemo(
        () => new Set([WMTransactionDetailsOptions.ShowDistinctItems]),
        []);

    // One gear button on the toolbar, not two. The row operations and Show Distinct Items used to be
    // separate DropDownButtons wearing the same icon, and their enablement was mutually exclusive, so
    // the operator always saw one dead gear beside a live one. Now a single list, ordered by
    // WMTransactionDetailsOptions to match Delphi's menu, with each item carrying its own enablement.
    // The `item.disabled === true` term preserves anything setActionDropDownItems already disabled for
    // transaction type or stage - the exemption above waives only the selected-row requirement.
    const operationItems = useMemo(() => {
        const noRowSelected = !selectedItemKeys.length;
        return (dropDownItems ?? []).map((item) => ({
            ...item,
            disabled: item.disabled === true || (noRowSelected && !ROW_INDEPENDENT_OPERATIONS.has(item.name)),
        }));
    }, [dropDownItems, selectedItemKeys, ROW_INDEPENDENT_OPERATIONS]);

    const handleDistinctItemSelected = async (itemCode) => {
        try 
        {
            const gridInstance = props.detailGrid.current.instance();
            
            // Constants for filter and sort
            const FILTER_FIELD_NAME = "name";
            const FILTER_OPERATOR_CONTAINS = "contains";
            const SORT_SELECTOR_NAME = "name";
            const API_SKIP = 0;
            const API_TAKE = 10;
            
            // First, find the item using GetItems API with filter
            const filter = JSON.stringify([[FILTER_FIELD_NAME, FILTER_OPERATOR_CONTAINS, itemCode]]);
            const sort = JSON.stringify([{ selector: SORT_SELECTOR_NAME, desc: false }]);
            
            const itemsResponse = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.Item.GetItems}`,
                {
                    params: {
                        skip: API_SKIP,
                        take: API_TAKE,
                        sort: sort,
                        filter: filter,
                        customerIdentity: props.formFields.R_CUSTOMER
                    },
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );

            // DevExtreme DataSourceLoadResult structure: { data: [...], totalCount: ..., groupCount: ..., summary: ... }
            let items = [];
            if (itemsResponse.data) {
                if (itemsResponse.data.data && Array.isArray(itemsResponse.data.data)) {
                    items = itemsResponse.data.data;
                } else if (Array.isArray(itemsResponse.data)) {
                    items = itemsResponse.data;
                }
            }
            
            // Find exact match by item code (name field)
            const matchingItem = items.find(item => 
                item && item.name && item.name.trim().toUpperCase() === itemCode.trim().toUpperCase()
            );

            if (!matchingItem) {
                const message = MESSAGES.ITEM_NOT_FOUND.replace("{0}", itemCode);
                notify(message, MESSAGES.ERROR, 3000);
                return;
            }

            // Check if there's already a new row being edited using the state
            let newRowIndex = -1;
            let rowKey = null;
            
            if (isNewRowActive) {
                // Find the new row that's currently being edited
                const rows = gridInstance.getVisibleRows();
                for (let i = rows.length - 1; i >= 0; i--) {
                    if (rows[i] && rows[i].isNewRow && rows[i].data) {
                        newRowIndex = i;
                        rowKey = rows[i].key;
                        break;
                    }
                }
            }
            
            // If no new row exists, add one
            if (newRowIndex === -1) {
                gridInstance.addRow();
                // Wait for the row to be added and onInitNewRow to fire
                await new Promise(resolve => setTimeout(resolve, 200));
                const updatedRows = gridInstance.getVisibleRows();
                if (updatedRows.length > 0) {
                    const lastRow = updatedRows[updatedRows.length - 1];
                    if (lastRow && lastRow.isNewRow) {
                        newRowIndex = updatedRows.length - 1;
                        rowKey = lastRow.key;
                    }
                }
            }

            // Wait a bit to ensure the row is ready
            await new Promise(resolve => setTimeout(resolve, 100));

            // Verify the row exists before proceeding
            const rows = gridInstance.getVisibleRows();
            if (newRowIndex >= 0 && newRowIndex < rows.length && rows[newRowIndex] && rows[newRowIndex].data) {
                const rowData = rows[newRowIndex].data;

                // No setValue on this: runLotProfileLogics only reads .component, to cancel the edit
                // when it hands the row off to a popup. The write goes through the grid below.
                const cellElement = {
                    component: gridInstance,
                    rowIndex: newRowIndex,
                    row: rows[newRowIndex],
                    data: rowData
                };

                var type = matchingItem.itemtype;
                const isNewRowFlag = true;
                let lot = null;
                
                // Run lot profile logics if needed (same as in the itemCode column's onValueChangeCallback)
                if (isNewRowFlag) {
                    try {
                        lot = await runLotProfileLogics(cellElement, matchingItem);
                    } catch (error) {
                        console.error("Error running lot profile logics:", error);
                    }
                }

                // The lot logic may have cancelled this edit and handed the row to a popup. Stop here if
                // so: writing the cell after that leaves a pending change for a row that is gone, which
                // the next addRow() flushes as an incomplete POST. See LOT_LOGIC_HANDLED.
                if (lot === LOT_LOGIC_HANDLED) {
                    return;
                }

                // One write, and the grid makes it. cellValue routes into the itemCode column's
                // setCellValue, so the change is recorded and the cell repainted by the same path a
                // user's own pick takes.
                //
                // What this replaced wrote straight into row.data behind the grid's back, which left
                // the grid unaware and forced a gridInstance.refresh() to make the value appear. That
                // refresh tore down and rebuilt the itemCode editor, and the rebuilt SelectBox
                // resolved the item byKey and applied it a second time - one pick produced two
                // GetItems?filter=[["id","=",<itemId>]] calls and ran the lot logic twice.
                const FIELD_NAME_ITEM_CODE = "itemCode";
                gridInstance.cellValue(newRowIndex, FIELD_NAME_ITEM_CODE, {
                    value: matchingItem.id,
                    text: matchingItem.name,
                    type: type,
                    isNewRow: isNewRowFlag,
                    lot: lot
                });

                // Constants for field names
                const FIELD_NAME_JDATE = "jDate";
                const FIELD_NAME_INVENTORY_UOM_FLAG = "inventoryUomFlag";
                const EDIT_CELL_DELAY_MS = 100;
                
                // Handle next cell editing based on conditions (same as in the itemCode column)
                var showMasterLot = props.profile?.ShowMasterLot;
                if (isNewRowFlag && ((pickMethods.ReceivingMethodLot == ReceivingMethodLot.Julian && props.formFields.TRANSACTIONTYPE === TransactionTypes.Receipt) || 
                    (pickMethods.LotMethod === MethodShipments.JulianDate && props.formFields.TRANSACTIONTYPE === TransactionTypes.Shipment)) && 
                    matchingItem.itemtype !== ItemTypes.Item) {
                    setTimeout(() => {
                        gridInstance.editCell(newRowIndex, FIELD_NAME_JDATE);
                    }, EDIT_CELL_DELAY_MS);
                } else if (isNewRowFlag && lot !== null && lot !== null && (showMasterLot == ShowMasterLot.Sequential || showMasterLot == ShowMasterLot.None || 
                    pickMethods.LotMethod === MethodShipments.AutoDefault)) {
                    setTimeout(() => {
                        gridInstance.editCell(newRowIndex, FIELD_NAME_INVENTORY_UOM_FLAG);
                    }, EDIT_CELL_DELAY_MS);
                }
            } else {
                console.error(MESSAGES.ERROR_FINDING_ROW_TO_EDIT);
                notify(MESSAGES.ERROR_FINDING_ROW_TO_EDIT, MESSAGES.ERROR, 3000);
            }
        }
        catch (error) {
            console.error(MESSAGES.ERROR_SELECTING_ITEM, error);
            notify(MESSAGES.ERROR_SELECTING_ITEM, MESSAGES.ERROR, 3000);
        }
    }

    const deleteItemChargesForSelectedItem = async () => {
        try {
            if (selectedItemKeys.length === 0) {
                alert(MESSAGES.TRANSACTION_DETAILS_NO_ROW_SELECTED, MESSAGES.ERROR);
                return;
            }
            
            setLoadPanelVisible(true);
            const detailId = selectedItemKeys[0];
            
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${data.Transaction.DeleteTransactionChargesByDetailId}`,
                detailId,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
            );
            
            const isSuccess = response.data?.isSuccess || false;
            const message = response.data?.message || response.data?.errorMessage || "Operation completed";
            
            if (isSuccess) {
                notify({
                    message: message,
                    width: 450,
                    type: "default",
                    displayTime: 3000,
                });
                // Refresh the charges grid if available
                if (props.detailTransactionChargesGrid?.current?.instance) {
                    props.detailTransactionChargesGrid.current.instance().refresh();
                }
            } else {
                notify({
                    message: message,
                    width: 450,
                    type: "error",
                    displayTime: 3000,
                });
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || "An error occurred";
            notify({
                message: errorMessage,
                width: 450,
                type: "error",
                displayTime: 3000,
            });
        } finally {
            setLoadPanelVisible(false);
        }
    };

    const deleteItemChargesForAllItems = async () => {
        try {
            setLoadPanelVisible(true);
            const headerId = props.formFields.ROWID;
            
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${data.Transaction.DeleteTransactionChargesByHeaderId}`,
                headerId,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
            );
            
            const isSuccess = response.data?.isSuccess || false;
            const message = response.data?.message || response.data?.errorMessage || "Operation completed";
            
            if (isSuccess) {
                notify({
                    message: message,
                    width: 450,
                    type: "default",
                    displayTime: 3000,
                });
                // Refresh the charges grid if available
                if (props.detailTransactionChargesGrid?.current?.instance) {
                    props.detailTransactionChargesGrid.current.instance().refresh();
                }
            } else {
                notify({
                    message: message,
                    width: 450,
                    type: "error",
                    displayTime: 3000,
                });
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || "An error occurred";
            notify({
                message: errorMessage,
                width: 450,
                type: "error",
                displayTime: 3000,
            });
        } finally {
            setLoadPanelVisible(false);
        }
    };

    const cancelLineItems = async () => {
        try {
            if (selectedItemKeys.length === 0) {
                alert(MESSAGES.TRANSACTION_DETAILS_NO_ROW_SELECTED, MESSAGES.ERROR);
                return;
            }
            if (props.formFields.TRANSACTIONTYPE === LocationStatus.ShipmentsOnly) {
                setLoadPanelVisible(true);
                const res = await axios.post(
                    `${window._env_.REACT_APP_APIS}/${data.Transaction.CancelTransactionLineItem}`,
                    selectedItemKeys[0],
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                if(props.detailGrid && props.detailGrid.current)
                    props.detailGrid.current.instance().refresh();
                if(props.canceledItemsTabGrid && props.canceledItemsTabGrid.current)
                    props.canceledItemsTabGrid.current.instance().refresh();
                return res.data;
            }
        } catch (error) {
            // This is the last stop: onItemClick awaits this without a catch of its own, and the endpoint
            // now reports a refusal as a real status instead of 200-with-a-flag, so rethrowing here would
            // surface as an unhandled rejection and the user would see nothing at all.
            if (error?.[CONCURRENCY_HANDLED]) {
                return;
            }
            alert(getApiErrorMessage(error, MESSAGES.ERROR), "Error");
        }
        finally {
            setLoadPanelVisible(false);
        }
    }
    const disableLotCode = () => {
       var showMasterLot = props.profile?.ShowmasterLot;
      if (props.formFields.TRANSACTIONTYPE === LocationStatus.ReceiptsOnly) {
        if (pickMethods.ReceivingMethodLot == ReceivingMethodLot.Sequential && showMasterLot == ShowMasterLot.QuickEntry) {
            return true;
        }
        else if (pickMethods.ReceivingMethodLot == ReceivingMethodLot.Manual) {
            return false;
        }
        if (showMasterLot == ShowMasterLot.Sequential || showMasterLot == ShowMasterLot.None) {
            return true;
        }
        else if (pickMethods.ReceivingMethodLot == ShowMasterLot.Sequential && (showMasterLot == ShowMasterLot.Yes || showMasterLot == ShowMasterLot.Full)) {
            return true;
        }
    }
        return false;
    }

    const runLotProfileLogics = async (cellElement, e) => {
        try
        {
            if(!e)
                return null;
            const itemType = e.itemtype;
            if (props.formFields.TRANSACTIONTYPE === LocationStatus.ReceiptsOnly && itemType !== ItemTypes.Item) 
            {
                if (pickMethods.ReceivingMethodLot == ReceivingMethodLot.Sequential)
                    setLoadPanelVisible(true);
                var showMasterLot = props.profile?.ShowmasterLot;
                if (pickMethods.ReceivingMethodLot == ReceivingMethodLot.Sequential && showMasterLot == ShowMasterLot.QuickEntry) 
                {
                    let lotCode = await getNextTransNumber();
                    let params = {
                        ItemRowId: e.id,
                        LotCode: lotCode,
                        IsAvaiable: false
                    }
                    let lot = await getLotById(params);
                    if (!lot || !lot.LotId) {
                        lot = await insertLot(e, lotCode);
                    }
                     if (lot && lot.LotId){
                     setShowQuickLotEntryScreen({isVisible:true,insertedLotId:lot.LotId,itemcode:e.name});
                    }
                    return lot;
                    
                }
                if (pickMethods.ReceivingMethodLot == ReceivingMethodLot.Sequential && (showMasterLot == ShowMasterLot.Sequential || showMasterLot == ShowMasterLot.None)) 
                {
                    //Get lot by item and Lot cell will be disabled
                    let lotCode = await getNextTransNumber();
                    let params = {
                        ItemRowId:e.id,
                        ItemRowId:e.id,
                        LotCode:lotCode,
                        IsAvaiable:false
                    }
                    let lot = await getLotById(params);
                    if (!lot || !lot.LotId) {
                        lot = await insertLot(e, lotCode);
                    }
                    return lot;
                }
                else if (pickMethods.ReceivingMethodLot == ShowMasterLot.Sequential && (showMasterLot == ShowMasterLot.Yes || showMasterLot == ShowMasterLot.Full)) {
                    //Show the full screen of Lot entry
                    let lotCode = await getNextTransNumber();
                    let params = {
                        ItemRowId: e.id,
                        ItemRowId: e.id,
                        LotCode: lotCode,
                        IsAvaiable: false
                    }
                    let lot = await getLotById(params);
                    if (!lot || !lot.LotId) {
                        lot = await insertLot(e, lotCode);
                    }
                    if (lot && lot.LotId){
                       setLotId(lot.LotId);
                       setShowLotEntryScreen(true);
                    }
                       
                    return lot;
                }
            }
           else if (props.formFields.TRANSACTIONTYPE === LocationStatus.ShipmentsOnly && itemType !== ItemTypes.Item
            && (props.formFields.STAGE === TransactionStage.Ready || props.formFields.STAGE === TransactionStage.Completed))
            {
                // for Shipment Transaction - Inventory Codes
                if (pickMethods.LotMethod === MethodShipments.ShowList && itemType === ItemTypes.SubLot)
                {
                    const grid = cellElement.component;
                    grid.cancelEditData()
                    setShowLotSublotEntryScreen({ IsOpen: true, ItemId: e.id, ShipDate: props.formFields.ACTUALRECEIVEDSHIPPEDDATETIME?? props.formFields.TRANSACTIONDATE });
                    return LOT_LOGIC_HANDLED;
                }
                else if(pickMethods.LotMethod === MethodShipments.AutoSelect && itemType === ItemTypes.Lot)
                {
                    const grid = cellElement.component;
                    grid.cancelEditData()
                    itemRef.current =e.id;
                    setShowAutoSelectLotScreen({IsOpen: true,ItemType:ItemTypes.Lot});
                    return LOT_LOGIC_HANDLED;
                }
                else if(pickMethods.SublotMethod === MethodShipments.AutoSelect && itemType === ItemTypes.SubLot)
                {
                    const grid = cellElement.component;
                    grid.cancelEditData()
                    itemRef.current = e.id;
                    setShowAutoSelectLotScreen({IsOpen: true,ItemType:ItemTypes.SubLot});
                    return LOT_LOGIC_HANDLED;
                }
                else if(pickMethods.LotMethod === MethodShipments.ShowList && itemType === ItemTypes.Lot)
                {
                    // Delphi opens Manually Select Lots For Shipment automatically from edtP_ItemExit
                    // (uWMD0002.pas:5613) and cancels the in-progress detail row before showing it
                    // (uWMD0002.pas:14409-14410), letting the screen create one detail per selected
                    // lot. Nothing is persisted yet, so RTransactionDetail stays null and
                    // ApplyManualLotSelection treats the original detail as absent. Mirrors the
                    // sublot-tracked branch above, which Delphi routes to WMD0109-custom.
                    const grid = cellElement.component;
                    grid.cancelEditData();
                    setManuallySelectLotsForShipment({ IsOpen: true, ItemId: e.id, RTransactionDetail: null });
                    return LOT_LOGIC_HANDLED;
                }
                else if (pickMethods.LotMethod === MethodShipments.AutoDefault) 
                {
                    let params = {
                        ItemRowId: e.id,
                        IsAvaiable: true,
                        OrderBy:getKeyByValue(LotPickMethodShipments,pickMethods.LotPickMethod),
                        IsDescendingOrder: pickMethods.LotPickSeqMethod === PickSequence.Descending
                    }

                    let lot = await getLotById(params);
                    
                    return lot;
                }
           }
        }
        catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
            throw error;
        } finally {
            hideLoadPanel();
        }

    }
    const getNextTransNumber = async () => {
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.AB.GetTransactionNo}`,
                {
                    params: {
                        Module: WM,
                        TransactionType: TransactionTypes.Lot,
                    },
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
            throw error;
        }
    };
    const getLotById = async (params) => {
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.Lot.GetLot}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
                params
            });
            if (response.data) {
                let lot = {
                    LotCode: response.data.lotCode,
                    LotId: response.data.rowId,
                };
                return lot;
            }
            return null;
        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
        }
    };
const insertLot = async (item,lotCode) => {

    try {
        let fields = {
            ROWID: "00000000-0000-0000-0000-000000000000",
            MODULE: WM,
            RECORDTYPE: TransactionTypes.Receipt,
            R_ITEM: item.id,
            R_ITEM: item.id,
            CUSTOMERCODE: props.formFields.R_CUSTOMER,
            LOTCODE: lotCode,
            STATUS: TransactionStatus.Active,
            INTRANSACTIONNUMBER: props.formFields.TRANSACTIONNUMBER,
            R_GLDEPARTMENT: null,
            R_CAJOB: null,
            R_GLFUND: null,
            USERDEFINEDREFERENCE_1:null,
            USERDEFINEDREFERENCE_2:null
        };
        if(defaultItemLotManagementUnit === DefaultItemLotManagementUnit.DefaultFromItemMasterRecord){
            fields.R_GLDEPARTMENT = item.rGlDepartment;
            fields.R_CAJOB = item.rCaJobCode;
            fields.R_GLFUND = item.rGlFund;
        }
        else if (defaultItemLotManagementUnit === DefaultItemLotManagementUnit.DefaultFromTransactionHeaderRecord) {
            fields.R_GLDEPARTMENT = props.formFields.R_GLDEPARTMENT;
            fields.R_CAJOB = props.formFields.R_CAJOB;
            fields.R_GLFUND = props.formFields.R_GLFUND;
        }
        if(populateLotWithCarrier ===  PopulateLotWithCarrier.PopulateCarrierIdAndScac){
            fields.USERDEFINEDREFERENCE_1 = props.formFields.Carrier.IdentityId;
            fields.USERDEFINEDREFERENCE_2 = props.formFields.Carrier.Scaccode;
        }
        else if (populateLotWithCarrier ===  PopulateLotWithCarrier.PopulateCarrierId) {
            fields.USERDEFINEDREFERENCE_1 = props.formFields.Carrier.IdentityId;
        }
        const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.Lot.Insert}`, fields, {
            headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
            },
        });

        if (!response.data.ERRORS || response.data.ERRORS.length === 0) {
            let lot = {
                LotCode: lotCode,
                LotId: response.data.ROWID,
            };
            return lot; 
        }

        return null; 
    } catch (error) {
        console.error(error);
        return null; // ✅ always return something
    } 
};
const autoSelectLotScreenClose = () => {
    setShowAutoSelectLotScreen(false);
};
    const autoSelectLotScreenSubmit = () => {
        setLoadPanelVisible(true);
        let grid = props.detailGrid.current.instance();
        const ds = grid.getDataSource();
        const store = ds.store();
        const requestData = {
            itemId: itemRef.current,
            rTransactionheader: props.formFields.ROWID,
            RecordType: props.formFields.RECORDTYPE,
            HeaderRowId: props.formFields.ROWID,
            TransactionType: props.formFields.TRANSACTIONTYPE,
            FromStage: TransactionTypes.Invoice,
            Stage: props.formFields.STAGE,
            DetailRowId: formFields.ROWID,
            SubDetailRowId: null,
            DefaultReceiptWH: null,
            ReceiptLocationMethod: props.profile?.LocationmethodReceipts,
            LocationMethod: pickMethods.LocationMethod ?? MethodShipments.AutoSelect,
            LocationPickMethod: pickMethods.LocationPickMethod, //m
            LocationPickSequence: pickMethods.LocationPickSeqMethod, //seq
            LotMethod: pickMethods.LotMethod ?? MethodShipments.Manual,
            LotPickMethod: pickMethods.LotPickMethod ?? LotPickMethodShipments.LotCode,
            LotPickSequence: pickMethods.LotPickSeqMethod,
            SublotMethod: pickMethods.SublotMethod,
            SublotPickMethod: pickMethods.SublotPickMethod ?? SublotPickMethodShipments.SublotCode,
            SublotPickSequence: pickMethods.SublotPickSeqMethod ?? PickSequence.Ascending,
            UnitMethod: pickMethods.UnitMethod,
            UnitPickMethod: pickMethods.UnitPickMethod ?? UnitPickMethodShipments.UnitCode,
            UnitPickSequence: pickMethods.UnitPickSeqMethod ?? PickSequence.Ascending,
            ShipmentsOnNegAvl: props.profile?.ShipmentsonnegAvl ?? ShowMasterLot.None,
            Mode: ShowMasterLot.None,
            ActualQuantity: pickMethods.ActualQuantity,
            QuantityOrdered: pickMethods.QuantityOrdered,
            OriginalQuantityOrder: pickMethods.OriginalQuantityOrder
        }
        store.insert(requestData)
            .then((insertedRow) => {
                console.log("Inserted row from server:", insertedRow);
                grid.cancelEditData()
                ds.reload();
                hideLoadPanel();
                setShowAutoSelectLotScreen(false);
            })
            .catch((err) => {
                console.error("Insert failed:", err);
                setShowAutoSelectLotScreen(false);
                grid.cancelEditData();
                hideLoadPanel();
            })
    }   
    
    const onLotSublotSelect = async (selectedLots) => {
        if (selectedLots) {
            const params = selectedLots;
            populateTransactionDetailObjects(params, {
                headerFormFields: props.formFields,
                detailFormFields: formFields,
                pickMethods: pickMethods,
                profile: props.profile,
                fromStage: TransactionStageEnum.Plan
            });
            setShowLotSublotEntryScreen({ IsOpen: false, ItemId: null, ShipDate: null });
            // The endpoint now reports a refusal as a real status rather than 200-with-a-flag. Without this
            // try/catch the rejection would escape an async handler nobody awaits — an unhandled rejection,
            // and the user would see the popup close with nothing saved and no message.
            try {
                await axios.post(`${window._env_.REACT_APP_APIS}/${data.Transaction.InsertTransactionDetailsInBatch}`, params, {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                });
                RefereshGrid();
            } catch (error) {
                if (!error?.[CONCURRENCY_HANDLED]) {
                    alert(getApiErrorMessage(error, MESSAGES.ERROR), "Error");
                }
            }
            props.detailGrid.current.instance().cancelEditData();
        }
    }
    const onSublotByConsigneeSelect = async (selectedSubLots) => {
        if (selectedSubLots) {
            const params = selectedSubLots;
            populateTransactionDetailObjects(params, {
                headerFormFields: props.formFields,
                detailFormFields: formFields,
                pickMethods: pickMethods,
                profile: props.profile,
                fromStage: TransactionStageEnum.Plan
            });
            setShowSublotByConsigneeScreen({ IsOpen: false, ConsigneeId: null});
            // See onLotSublotSelect above — same endpoint, same reason for the try/catch.
            try {
                await axios.post(`${window._env_.REACT_APP_APIS}/${data.Transaction.InsertTransactionDetailsInBatch}`, params, {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                });
                RefereshGrid();
            } catch (error) {
                if (!error?.[CONCURRENCY_HANDLED]) {
                    alert(getApiErrorMessage(error, MESSAGES.ERROR), "Error");
                }
            }
            props.detailGrid.current.instance().cancelEditData();
        }
    }
    const onManualItemLotScreenClose = () => {
        props.detailGrid.current.instance().cancelEditData();
        setShowLotSublotEntryScreen({ IsOpen: false, ItemId: null, ShipDate: null });
    }
    const handleManuallySelectLotsForShipmentSave = () => {
        setTimeout(() => {
            RefereshGrid();
            props.changeTotals();
            if (props.locationDataGridRef.current?.instance) {
                props.locationDataGridRef.current.instance().refresh();
            }
            if (props.subLotdataGridRef.current?.instance) {
                props.subLotdataGridRef.current.instance().refresh();
            }
        }, 100);
        setManuallySelectLotsForShipment({ IsOpen: false, ItemId: null, RTransactionDetail: null });
    }  
    
    const handleManuallySelectSublotsAndLotsForShipmentSave =  () => {
       setTimeout(() => {
            RefereshGrid();
            props.changeTotals();
            if (props.locationDataGridRef.current?.instance) {
                props.locationDataGridRef.current.instance().refresh();
            }
            if (props.subLotdataGridRef.current?.instance) {
                props.subLotdataGridRef.current.instance().refresh();
            }
        }, 100);
        setManuallySelectSublotsAndLotsForShipment(false);
    }
    const customToolbarItems = [
        <DataGridToolbarItem location="before" key="edit">
            <Button
            disabled={!selectedRow}
                onClick={() => {
                    setShowLotDataEntryListingPopup({ visible: false });
                    const gridInstance = props.detailGrid.current.instance();
                    gridInstance.addRow();
                }}
                type="default"
                text="Ok"
            ></Button>
        </DataGridToolbarItem>,
    ];
    return (
        <div>
          <LoadPanel
             shadingColor="rgba(0,0,0,0.4)"
             position={position}
             onHiding={hideLoadPanel}
             visible={loadPanelVisible}
             showIndicator={true}
             shading={true}
             showPane={true}
             hideOnOutsideClick={false}
         />
            <DataGrid
                dataSource={dataSource}
                ref={props.detailGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                onSelectionChanged={onSelectionChanged}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onInitNewRow={onInitNewRow}
                onRowUpdated={onRowUpdated}
                onRowInserted={onRowInserted}
                onRowInserting={rowInserting}
                onContentReady={onContentReady}
                onEditCanceled={onEditCanceled}
                onRowUpdating={onRowUpdating}
                height="40vh"
                onEditingStart={onEditingStart}
                onEditorPreparing={onEditorPreparing}
                onRowValidating={ValidateTransactionDetailLineItemWarnings}
            >
                 <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                 <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting mode="none"/>
                <Paging enabled={false} />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                    allowAdding={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                    newRowPosition="last"
                />
                <FilterRow visible={true} />
                <Column dataField="keySequence" caption='Key Sequence' visible={false} allowSorting={false} showInColumnChooser={false}/>
                <Column dataField="itemId" caption='Item Id' visible={false} allowSorting={false} showInColumnChooser={false}/>
                <Column dataField="itemCode" caption="Item"allowSorting={false} visibleIndex={0}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Item.GetItems}`,
                            loadParams: {
                                customerIdentity: props.formFields.R_CUSTOMER // Pass your custom parameter here
                            },
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.itemId,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: async (value, text, e) => {
                                var type = e?.itemtype;
                                const isNewRow = cellElement.row.isNewRow;
                                let lot=null;
                                if (isNewRow){
                                   lot=await runLotProfileLogics(cellElement,e);
                                }

                                // The lot logic may have cancelled this edit and handed the row to a
                                // popup. Stop before setValue and before the editCell calls below:
                                // touching a cancelled cell leaves a pending change for a row that no
                                // longer exists, which the next addRow() flushes as an incomplete POST.
                                // See LOT_LOGIC_HANDLED.
                                if (lot === LOT_LOGIC_HANDLED) {
                                    return;
                                }

                                cellElement.setValue(({ value, text, type, isNewRow,lot }));
                                 var showMasterLot = props.profile?.ShowmasterLot;
                                if (isNewRow && ((pickMethods.ReceivingMethodLot == ReceivingMethodLot.Julian && props.formFields.TRANSACTIONTYPE === TransactionTypes.Receipt) || (pickMethods.LotMethod === MethodShipments.JulianDate && props.formFields.TRANSACTIONTYPE === TransactionTypes.Shipment)) && selectedDetails?.itemType !== ItemTypes.Item) {
                                    const grid = cellElement.component;
                                    grid.editCell(cellElement.rowIndex, "jDate");
                                }
                               else if(isNewRow && lot !==null && lot !==null && showMasterLot == ShowMasterLot.Sequential || showMasterLot == ShowMasterLot.None || pickMethods.LotMethod === MethodShipments.AutoDefault){
                                     const grid = cellElement.component;
                                    grid.editCell(cellElement.rowIndex, "inventoryUomFlag");
                                }

                            },
                        })
                    }
                    
                    setCellValue={(rowData, newValue) => {
                        rowData.itemCode = newValue.text;
                        rowData.itemId = newValue.value;
                        rowData.type = newValue.type;
                        if(newValue.lot){
                        rowData.lotId = newValue.lot.LotId; 
                        rowData.lotCode = newValue.lot.LotCode; 
                        }
                    }}
                >
                </Column>
                {(pickMethods.ReceivingMethodLot == ReceivingMethodLot.Julian || pickMethods.LotMethod === MethodShipments.JulianDate) && selectedDetails?.itemType !== ItemTypes.Item && (props.formFields.TRANSACTIONTYPE === TransactionTypes.Receipt || props.formFields.TRANSACTIONTYPE === TransactionTypes.Shipment)
                    && (<Column dataField="jDate" caption="" allowSorting={false} visibleIndex={1}
                        editCellRender={(cellElement) => {
                            if (cellElement.row?.isNewRow) {
                                return ( <DateBox
                                    onInitialized={(e) => {
                                        e.component.open();
                                    }}
                                    onValueChanged={(e) => {
                                        cellElement.setValue(dateTimeToJulian(e.value));
                                        const grid = cellElement.component;
                                        grid.editCell(cellElement.rowIndex, "inventoryUomFlag");
                                    }}
                                />)
                            }
                            return null;
                        }
                        }
                        setCellValue={(rowData, newValue) => {
                            rowData.lotCode = newValue.toString();
                        }}
                    />)}
                <Column dataField="lotId" caption='lot Id' visible={false} allowSorting={false} showInColumnChooser={false}/>
                <Column dataField="lotCode" caption="Lot" allowSorting={false} 
                allowEditing={disableLotCode()==true? false : true}
                    editCellRender={(cellElement) =>
                        <SelectBox
                           dataSource={
                                { 
                                    store: createStore({
                                        loadUrl: `${window._env_.REACT_APP_APIS}/${data.Lot.GetLots}`,
                                        key: "id",
                                        loadParams: {
                                            masterRowId: function () {
                                                return cellElement.row.data?.itemId;
                                            }
                                        },
                                        onBeforeSend: function (method, ajaxOptions) {
                                            ajaxOptions.headers = {
                                                Authorization: `Bearer ${accessToken}`,
                                            };
                                        },
                                    }),
                                    sort: [{ selector: "name", desc: false }],
                                    paginate: true,
                                    pageSize: 10,
                                }
                            }
                            valueExpr="id"
                            displayExpr="name"
                            searchEnabled={true}
                            searchMode="contains"
                            defaultValue={cellElement.data.lotId}
                            acceptCustomValue={true}
                            showClearButton={true}
                            onSelectionChanged={(e) => {
                                var i = 0;
                                i++;
                            }}
                            onValueChanged={(e) => {
                                var text = e.component.option("displayValue");
                                const value = e.value;
                                cellElement.setValue({ value, text });
                            }}
                            onCustomItemCreating={(e) => {
                                if (e.text) 
                                {
                                    if (cellElement.row?.isNewRow && props.profile?.Lotcodeentrymethod === "Y" && successLotCode !== e.text)
                                    {
                                        if(!lotRetry)
                                        {
                                            oldLotCode = e.text;
                                            lotRetry = true;
                                            cellElement.setValue(({ value: "", text: "[RETYPELOTCODE]" }));
                                            alert("Please Re-Type the Lot Code for validation.", "Error").then(() => {
                                                props.detailGrid.current.instance().focus(cellElement);
                                                props.detailGrid.current.instance().editCell(cellElement.rowIndex, "lotCode");
                                            });
                                            e.customItem = null;
                                            skipLotCodeUpdate = true;
                                            return;
                                        }
                                        else
                                        {
                                            lotRetry = false;
                                            if (oldLotCode !== e.text)
                                            {
                                                oldLotCode = "";
                                                cellElement.setValue(({ value: "", text: "[LOTVALIDATIONFAILED]" }));
                                                alert("Lot Code validation failed.", "Error").then(() => {
                                                    props.detailGrid.current.instance().focus(cellElement);
                                                    props.detailGrid.current.instance().editCell(cellElement.rowIndex, "lotCode");
                                                    
                                                });
                                                e.customItem = null;
                                                skipLotCodeUpdate = true;
                                                return;
                                            }
                                            else
                                            {
                                                successLotCode = e.text;
                                            }

                                        }

                                    }

                                    cellElement.setValue(({ value: e.text, text: e.text }));
                                    e.customItem = {"id": e.text, "name": e.text , "itemtype": null, "description": null,  "id2": null};
                                    skipLotCodeUpdate = true;
                                }
                            }}
                        >
                        </SelectBox>
                    }
                    setCellValue={(rowData, newValue) => {
                        if(!skipLotCodeUpdate)
                        {
                            rowData.lotCode = newValue.text;
                            rowData.lotId = newValue.value;
                        }
                        skipLotCodeUpdate = false;

                    }}
                >
                
                </Column>
                
                <Column
                    caption="Trans Unit"
                    dataField="inventoryUomFlag"
                    allowSorting={false}
                >
                    <Lookup
                        dataSource={uomArray}
                        valueExpr="flagvalue"
                        displayExpr="flagdescription"
                    />
                </Column>
                <Column
                    caption="Ordered"
                    dataField="quantityordered"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                    allowSorting={false}
                />
                <Column
                    caption="Actual"
                    dataField="actualQuantity"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                    allowSorting={false}
                    allowEditing={!['P', 'F', 'N'].includes(props.formFields.STAGE)}
                />
                <Column
                    caption="UOM"
                    dataField="quantityInventoryUOM"
                    allowEditing={false}
                    allowSorting={false}
                ></Column>
                <Column
                    caption="Inventory"
                    dataField="inventoryUnits"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                    allowEditing={false}
                    allowSorting={false}
                />
                <Column
                    caption="UOM"
                    dataField="inventoryUnitUOM"
                    allowEditing={false}
                    allowSorting={false}
                ></Column>
                <Column
                    caption="Amount"
                    dataField="amount"
                    allowEditing={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                    allowSorting={false}
                />
                <Column caption="Item Desc 1" dataField="itemDesc1" dataType="string" visible={false} allowEditing={false} allowSorting={false}></Column>
                <Column caption="Item Desc 2" dataField="itemDesc2" dataType="string" visible={false} allowEditing={false} allowSorting={false}></Column>
                <Column caption="Lot Desc 1" dataField="lotDesc1" dataType="string"  visible={false} allowEditing={false} allowSorting={false}></Column>
                <Column caption="Lot Desc 2" dataField="lotDesc2" dataType="string"  visible={false} allowEditing={false} allowSorting={false}></Column>
                <Column caption="Item Trans Unit" dataField="itemAvailableConverted" dataType="number" visible={false} allowEditing={false} allowSorting={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                <Column caption="Lot Trans Unit" dataField="lotAvailableConverted" dataType="number" visible={false} allowEditing={false} allowSorting={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                <Column caption="Item Available" dataField="itemAvailable" dataType="number" visible={false} allowEditing={false} allowSorting={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                <Column caption="Lot Available" dataField="lotAvailable" dataType="number" visible={false} allowEditing={false} allowSorting={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }}
                />
                <Column dataField="comment" caption="Comment" dataType="string" visible={false} allowSorting={false}
                    editorType="dxTextArea"
                    editorOptions={{ 
                        autoResizeEnabled: true 
                    }}
                />
                <Column dataField="userDefinedComment" caption="User Defined Comment" dataType="string" visible={false} allowSorting={false}
                    editorType="dxTextArea"
                    editorOptions={{ 
                        autoResizeEnabled: true 
                    }}
                />
                <Column visible={false} dataField="netWeightQuantity" caption="Net Weight" dataType="number" allowSorting={false} allowEditing={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 4,
                        useGrouping: true
                    }}
                />
                <Column visible={false} dataField="grossWeightQuantity" caption="Gross Weight" dataType="number" allowSorting={false} allowEditing={false} 
                    format={{
                        type: 'fixedPoint',
                        precision: 4,
                        useGrouping: true
                    }}
                />
                <Column visible={false} dataField="reference" caption="Reference " dataType="string" editorOptions={{ maxLength: 50 }} allowSorting={false}/>
                <Column visible={false} dataField="detailStatus" caption="Status" dataType="string" allowSorting={false} allowEditing={false}/>
                <Column visible={false} dataField="overrideShipDays" caption="Override Ship Days" dataType="string" allowSorting={false} >
                    <Lookup
                        dataSource={ [
                            {
                                flagvalue: "Y",
                                flagdescription: "Yes"
                            },
                            {
                                flagvalue: "N",
                                flagdescription: "No"
                            }]}
                        valueExpr="flagvalue"
                        displayExpr="flagdescription"
                    />
                </Column>
                <DataGridToolbar>
                    <DataGridToolbarItem
                        name="addRowButton"    
                        disabled={props.disableGridsForRFTransactions === true} 
                        onClick={()=>setSelectedRow(null)}              
                    />
                    <DataGridToolbarItem location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length || (props.disableGridsForRFTransactions === true || props.isCommittedTransaction === true )}
                        />
                    </DataGridToolbarItem>
                    <DataGridToolbarItem location="after">
                           <DropDownButton
                             icon="fa fa-cogs"
                             stylingMode="text"
                             items={operationItems}
                             dropDownOptions={{ width: 'auto', minWidth: 300 }}
                             displayExpr="name"
                             onItemClick={onItemClick}
                             disabled={operationItems.every((item) => item.disabled) || (props.disableGridsForRFTransactions === true || props.isCommittedTransaction === true )}
                        />
                    </DataGridToolbarItem>
                    <DataGridToolbarItem location="after">
                        <div className="separator"></div>
                    </DataGridToolbarItem> 
                    <DataGridToolbarItem location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={props.detailGrid} setCurrentLayout={setCurrentLayout} />
                    </DataGridToolbarItem>                  
                    <DataGridToolbarItem name="exportButton" />
                    <DataGridToolbarItem name="columnChooserButton" />
                </DataGridToolbar>
            </DataGrid>
            <TabPanel  selectedIndex={selectedTabIndex} onSelectionChanged={handleTabSelectionChange}   style={{ height: 'calc(70vh - 200px)'}}  ref={tabPanelRef}>
                <TabItem title="Primary"  visible={(selectedDetails?.itemType !==ItemTypes.SubLot && (props.profile?.Uselocation===Options.No?false:true))} >
                    <PrimaryTab RefereshGrid={RefereshGrid} sourceId={selectedItemKeys.length > 0  ? selectedItemKeys[0] : null} dataGrid={primaryDataGrid} transactionType={props?.formFields?.TRANSACTIONTYPE} isCommittedTransaction={props.isCommittedTransaction} profile={props.profile} selectedDetails={selectedDetails}></PrimaryTab>
                </TabItem>
                <TabItem title="Sublots" visible={(selectedDetails?.itemType===ItemTypes.SubLot)}>
                    <SubLotDetailTabs changeTotals={props.changeTotals} formFields={props.formFields} selectedLotRowId={selectedLotRowId} selectedItemRowId={selectedItemRowId}  RefereshGrid={RefereshGrid} sourceId={selectedItemKeys.length > 0  ? selectedItemKeys[0] : null} subLotdataGridRef={props.subLotdataGridRef}  locationDataGridRef={props.locationDataGridRef}  disableGridsForRFTransactions={props.disableGridsForRFTransactions}  isCommittedTransaction={props.isCommittedTransaction} headerId={props.formFields.ROWID} profile={props.profile} selectedDetails={selectedDetails} setSelectedSubLot={setSelectedSubLot} openAutoSelectLocationsPopup={openAutoSelectLocationsPopup}></SubLotDetailTabs>
                </TabItem>
                <TabItem title="Serial Numbers" visible={
                selectedDetails && (selectedDetails?.transactiontype === TransactionTypes.Receipt || selectedDetails?.transactiontype === TransactionTypes.Shipment)
            && (selectedDetails?.itemType === ItemTypes.Item || selectedDetails?.itemType === ItemTypes.Lot || selectedDetails?.itemType === ItemTypes.SubLot)
            && (selectedDetails?.shipselection === Options.Yes || selectedDetails?.shipselection === ShipSelection.UserDefined)
                }>
                    <SerialNumbersTab rIndetail={selectedItemKeys.length > 0  ? selectedItemKeys[0] : null} 
                    selectedDetails={selectedDetails}
                    itemRowId={selectedItemRowId} lotRowId = {selectedLotRowId}
                    formFields={props.formFields}
                    disableGridsForRFTransactions={props.disableGridsForRFTransactions}
                    isCommittedTransaction={props.isCommittedTransaction} profile={props.profile}></SerialNumbersTab>
                </TabItem>
                 <TabItem title="User Defined">
                  <UserDefinedTab   key={refKey} selectedDetails={selectedDetails}   formFields={formFields} setformFields={setformFields} handleFormSubmit={handleFormSubmit} isCommittedTransaction={props.isCommittedTransaction} />
                </TabItem>
                 <TabItem title="Additional">
                  <AdditionalTab selectedDetails={selectedDetails} formFields={formFields} setformFields={setformFields} handleFormSubmit={handleFormSubmit}  isCommittedTransaction={props.isCommittedTransaction}/>
                </TabItem>
                <TabItem title="Comments">
                  <CommentTab selectedDetails={selectedDetails} formFields={formFields} setformFields={setformFields} handleFormSubmit={handleFormSubmit}  isCommittedTransaction={props.isCommittedTransaction}/>
                </TabItem>
                <TabItem title="Locations">
                    <LocationsTab itemRowId={selectedItemRowId} lotRowId = {selectedLotRowId}></LocationsTab>
                </TabItem>
                
                <TabItem title="Lot Info"  disabled={props.isCommittedTransaction == true}>
                    <LotInfoTab  itemRowId={selectedItemRowId} lotRowId = {selectedLotRowId}></LotInfoTab>
                </TabItem>
              
                <TabItem title="Charges"  visible={props.IsChargesTabVisible} >
                    <ChargesTab formFields={props.formFields} setformFields={props.setformFields} sourceId={selectedItemKeys.length > 0  ? selectedItemKeys[0] : null} transactionChargesGrid={props.detailTransactionChargesGrid}></ChargesTab>
                </TabItem>
            </TabPanel>
            {autoSelectLocationsPopup && (
             <AutoSelectLocationPopup  showPopup={autoSelectLocationsPopup} setShowPopup={setAutoSelectLocationsPopup}/>
            )}
             {generateLotSerialNumbers && (
                <Popup
                    visible={generateLotSerialNumbers}
                    onHiding={() => setGenerateLotSerialNumbers(false)}
                    width="40vw"
                    height="50vh"
                    title="Generate Lot/Serial Numbers"
                    showCloseButton={true}
                >
                    <div style={{ height: "100%", overflow: "auto" }}>
                    <GenerateLotSerialNumbers headerId={formFields.ROWID} setGenerateLotSerialNumbers={setGenerateLotSerialNumbers}/>
                    </div>
                </Popup>
            )}
              {showQuickLotEntryScreen.isVisible && (
                <Popup
                    visible={showQuickLotEntryScreen.isVisible}
                    onHiding={() => setShowQuickLotEntryScreen({isVisible:false,insertedLotId:null,itemCode:null})}
                    width="60vw"
                    height="75vh"
                    title="Wm Quick Lot Entry Screen"
                    showCloseButton={true}
                >
                    <div style={{ height: "100%", overflow: "auto" }}>
                    <QuickLotEntryScreen  showQuickLotEntryScreen={showQuickLotEntryScreen} setShowQuickLotEntryScreen={setShowQuickLotEntryScreen}/>
                    </div>
                </Popup>
            )}
             {showLotEntryScreen && (
                <Popup
                    visible={showLotEntryScreen}
                    onHiding={() => setShowLotEntryScreen(false)}
                    width="100vw"
                    height="100vh"
                    title=""
                    showCloseButton={true}
                >
                <LotDataEntryForm id={lotId} isOpenAsPopUp={true}/>
                </Popup>
            )}
              {showAutoSelectLotScreen.IsOpen && showAutoSelectLotScreen.ItemType === ItemTypes.Lot && (
                <Popup
                    visible={showAutoSelectLotScreen.IsOpen}
                    onHiding={() => setShowAutoSelectLotScreen({IsOpen:false,ItemType:ItemTypes.Lot})}
                    width="20vw"
                    height="auto"
                    title="Auto Select Lots"
                    showCloseButton={true}
                >
                <AutoSelectLotScreen pickMethods= {pickMethods} setPickMethods={setPickMethods} autoSelectLotScreenClose={autoSelectLotScreenClose} autoSelectLotScreenSubmit ={autoSelectLotScreenSubmit} />
                </Popup>
            )}
            {showAutoSelectLotScreen.IsOpen && showAutoSelectLotScreen.ItemType === ItemTypes.SubLot && (
                <Popup
                    visible={showAutoSelectLotScreen.IsOpen}
                    onHiding={() => setShowAutoSelectLotScreen({ IsOpen: false, ItemType: ItemTypes.Lot })}
                    width="20vw"
                    height="auto"
                    title="Auto Select Subots"
                    showCloseButton={true}
                >
                    <AutoSelectSublotScreen pickMethods={pickMethods} setPickMethods={setPickMethods} autoSelectLotScreenClose={autoSelectLotScreenClose} autoSelectLotScreenSubmit={autoSelectLotScreenSubmit} />
                </Popup>
            )}
            {showLotSublotEntryScreen.IsOpen && (
                <Popup
                    visible={showLotSublotEntryScreen.IsOpen}
                    onHiding={onManualItemLotScreenClose}
                    width="100vw"
                    height="100vh"
                    title="Manually Selects Lots & Sublots For Shipment"
                    showCloseButton={true}
                >
                    <LotsSublotForShipment params={showLotSublotEntryScreen} onManualItemLotScreenClose={onManualItemLotScreenClose} onLotSublotSelect={onLotSublotSelect} />
                </Popup>
            )}
                    {showSublotByConsigneeScreen.IsOpen && (
                <Popup
                    visible={showSublotByConsigneeScreen.IsOpen}
                    onHiding={() => setShowSublotByConsigneeScreen({IsOpen:false})}
                    width="100vw"
                    height="100vh"
                    title="Select Sublots By Consignee"
                    showCloseButton={true}
                >
                    <SublotByConsignee params={showSublotByConsigneeScreen}  onSublotByConsigneeSelect={onSublotByConsigneeSelect} />
                </Popup>
            )}
            {showDistinctItemsPopup && (
                <Popup
                    visible={showDistinctItemsPopup}
                    onHiding={() => setShowDistinctItemsPopup(false)}
                    onShown={() => {
                        // Ensure focus is released from the grid
                        const gridInstance = props.detailGrid.current.instance();
                        if (gridInstance && gridInstance.hasEditData()) {
                            gridInstance.cancelEditData();
                        }
                        // Blur any active element to release focus
                        if (document.activeElement && document.activeElement.blur) {
                            document.activeElement.blur();
                        }
                    }}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title="Show Distinct Items"
                    width="60vw"
                    height="70vh"
                >
                    <ShowDistinctItems 
                        transactionHeaderId={props.formFields.ROWID}
                        detailGrid={props.detailGrid}
                        accessToken={accessToken}
                        customerIdentity={props.formFields.R_CUSTOMER}
                        onClose={() => setShowDistinctItemsPopup(false)}
                        onItemSelected={handleDistinctItemSelected}
                    />
                </Popup>
            )}
            {showListAvailableShipmentLotsLocationsPopup && (
                <Popup
                    visible={showListAvailableShipmentLotsLocationsPopup}
                    onHiding={() => setShowListAvailableShipmentLotsLocationsPopup(false)}
                    onShown={() => {
                        // Ensure focus is released from the grid
                        const gridInstance = props.detailGrid.current.instance();
                        if (gridInstance && gridInstance.hasEditData()) {
                            gridInstance.cancelEditData();
                        }
                        // Blur any active element to release focus
                        if (document.activeElement && document.activeElement.blur) {
                            document.activeElement.blur();
                        }
                    }}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title="List Available Lots & Locations For Shipment"
                    width="80vw"
                    height="90vh"
                >
                    <ListAvailableShipmentLotsLocations 
                        onClose={() => setShowListAvailableShipmentLotsLocationsPopup(false)}
                        itemRowId={selectedItemRowId || selectedDetails?.itemId}
                    />
                </Popup>
            )}
            {showLotDataEntryListingPopup.visible == true && (
                <LotDataEntryListingPopup
                    showPopup={showLotDataEntryListingPopup}
                    setShowPopup={setShowLotDataEntryListingPopup}
                    toolbarItems={customToolbarItems}
                    setSelectedRow={setSelectedRow}
                />
            )}
            {applyItemRateSchedulePopup && (
                <ApplyItemRateSchedule showPopup={applyItemRateSchedulePopup} setShowPopup={setApplyItemRateSchedulePopup} />
            )}
            {manuallySelectLotsForShipment.IsOpen && (
                <Popup
                    visible={manuallySelectLotsForShipment.IsOpen}
                    onHiding={() => setManuallySelectLotsForShipment({ IsOpen: false, ItemId: null, RTransactionDetail: null })}
                    width="80vw"
                    height="70vh"
                    title="Manually Select Lots For Shipment"
                    showCloseButton={true}
                >
                    <ManuallySelectLotsForShipment 
                        rTransactionDetail={manuallySelectLotsForShipment.RTransactionDetail} 
                        CloseManuallySelectLotsForShipmentScreen={() => setManuallySelectLotsForShipment({ IsOpen: false, ItemId: null, RTransactionDetail: null })}
                        itemRowId={manuallySelectLotsForShipment.ItemId}
                        formFields={props.formFields}
                        profile={props.profile}
                        transactionHeaderId={props.formFields.ROWID}
                        handleManuallySelectLotsForShipmentSave={handleManuallySelectLotsForShipmentSave}
                    >

                    </ManuallySelectLotsForShipment>
                </Popup>
            )}
            {manuallySelectSublotsAndLotsForShipment && selectedItemKeys.length > 0 && (
                <Popup
                    visible={manuallySelectSublotsAndLotsForShipment}
                    onHiding={() => setManuallySelectSublotsAndLotsForShipment(false)}
                    width="100vw"
                    height="100vh"
                    title="Manually Selects Lots & Sublots For Shipment"
                    showCloseButton={true}
                >
                    <ManuallySelectSublotsAndLotsForShipment 
                        rTransactionDetail={selectedItemKeys[0]} 
                        CloseManuallySelectSublotsAndLotsForShipmentScreen={() => setManuallySelectSublotsAndLotsForShipment(false)}
                        handleManuallySelectSublotsAndLotsForShipmentSave={handleManuallySelectSublotsAndLotsForShipmentSave} 
                        ItemId={selectedItemRowId}
                        transactionHeaderId={props.formFields.ROWID}
                        ItemCode={selectedDetails?.itemCode}
                        ShipDate={props.formFields.ACTUALRECEIVEDSHIPPEDDATETIME?? props.formFields.TRANSACTIONDATE }
                    
                    />
                </Popup>
            )}
                         <AdjustAvailableUnAvailableStatusMainPopup
                            showPopup={ShowAdjustAvailableUnavailableStatusPopup}
                            setShowPopup={setShowAdjustAvailableUnavailableStatusPopup}
                            title="Adjust Available Unavailable Status"
                        />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(DetailsTab);